import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';

import { FullLayoutComponent } from './layouts/full-layout/full-layout.component';
import { CommonLayoutComponent } from './layouts/common-layout/common-layout.component';

import { FullLayout_ROUTES } from './shared/routes/full-layout.routes';
import { AdminLayout_ROUTES } from './shared/routes/admin-layout.route';
import { CommonLayout_ROUTES } from './shared/routes/common-layout.routes';
import { AuthGuard } from './shared/guard/auth.guard';


const appRoutes: Routes = [
    {
        path: '',
        redirectTo: '/accounting-software-integration/balance',
        pathMatch: 'full',
    },  
    // Dashboard
    { 
        path: '', 
        component: CommonLayoutComponent,
        children: CommonLayout_ROUTES,
        canActivate: [AuthGuard],
        data: {dashboard: true}
    },
    // Login
    { 
        path: '', 
        component: FullLayoutComponent, 
        children: FullLayout_ROUTES
    },
    // Admin
    // { 
    //     path: '', 
    //     component: CommonLayoutComponent, 
    //     children: AdminLayout_ROUTES
    // }  

];

@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes, { 
            preloadingStrategy: PreloadAllModules,
            useHash: true,
            scrollPositionRestoration: 'enabled' 
        })
    ],
    exports: [
        RouterModule
    ],
    providers: [AuthGuard]
})

export class AppRoutingModule {
}